import { render, staticRenderFns } from "./look_card.vue?vue&type=template&id=12ac1cb4&scoped=true"
import script from "./look_card.vue?vue&type=script&lang=js"
export * from "./look_card.vue?vue&type=script&lang=js"
import style0 from "./look_card.vue?vue&type=style&index=0&id=12ac1cb4&prod&lang=scss&scope=true"
import style1 from "./look_card.vue?vue&type=style&index=1&id=12ac1cb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac1cb4",
  null
  
)

export default component.exports